import Vue from 'vue';

const RECOVER_HASH = '#recover';

new Vue({
    el: '#template-login',

    delimiters: ['${', '}'],

    components: {
        
    },

    data: {
        isRecoverPasswordShown: false,
        isRecoverSuccessShown: false
    },

    mounted() {
        if (this.$refs.hasOwnProperty('isRecoverSuccess')) {
            this.isRecoverSuccessShown = true;
        }

        if (window.location.hash == RECOVER_HASH) {
            this.isRecoverPasswordShown = true;
        }
    },

    methods: {
        toggleRecoverPassword() {
            this.isRecoverPasswordShown = !this.isRecoverPasswordShown;

            if (this.isRecoverPasswordShown) {
                history.replaceState(null, null, RECOVER_HASH);
            } else {
                history.replaceState(null, null, ' ');
            }
        }
    }
});